import { AuthRedirectSpinner } from './auth-redirect-spinner';
import { PageRenderer } from './page-renderer';
import { withAuthenticationGuard } from './with-authentication-guard';

export const AuthGuardedPageRenderer = withAuthenticationGuard(PageRenderer, {
    OnRedirecting: AuthRedirectSpinner,
});
